import { render, staticRenderFns } from "./mobile-invitation-form.vue?vue&type=template&id=200e8942&scoped=true"
import script from "./mobile-invitation-form.vue?vue&type=script&lang=js"
export * from "./mobile-invitation-form.vue?vue&type=script&lang=js"
import style0 from "./mobile-invitation-form.vue?vue&type=style&index=0&id=200e8942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200e8942",
  null
  
)

export default component.exports